import { ArrowRight, ArrowUpRight } from "lucide-react";
import { HERO_IMAGE } from "../assets";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-[140px] md:pt-[160px] pb-20 md:pb-28"
    >
      <div className="nr-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <span className="nr-eyebrow nr-fade-up">
              Operador profesional · Coliving residencial
            </span>
            <h1
              data-testid="hero-headline"
              className="nr-display mt-6 nr-fade-up"
              style={{ animationDelay: "60ms" }}
            >
              Alquila tu vivienda sin preocupaciones y{" "}
              <span className="text-[#2E8E92]">cobra cada mes</span>.
            </h1>
            <p
              data-testid="hero-subheadline"
              className="mt-7 text-[17px] md:text-[19px] leading-[1.6] max-w-[640px] nr-text-soft nr-fade-up"
              style={{ animationDelay: "120ms" }}
            >
              Reformamos, optimizamos y gestionamos tu vivienda. Nos
              convertimos en tu inquilino para que recibas tu renta puntualmente
              cada mes, sin impagos, sin gestión y sin dolores de cabeza.
            </p>

            <div
              className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4 nr-fade-up"
              style={{ animationDelay: "180ms" }}
            >
              <a
                href="#contacto"
                data-testid="hero-cta-primary"
                className="nr-btn nr-btn-primary"
              >
                Reservar llamada gratuita <ArrowRight size={16} />
              </a>
              <a
                href="#proceso"
                data-testid="hero-cta-secondary"
                className="nr-btn nr-btn-ghost"
              >
                Descubrir cómo trabajamos <ArrowUpRight size={16} />
              </a>
            </div>

            <div
              className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4 text-[13px] nr-text-soft nr-fade-up"
              style={{ animationDelay: "240ms" }}
            >
              <span className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#43A4A8]" />
                Pago puntual cada mes
              </span>
              <span className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#43A4A8]" />
                Sin coste de reforma
              </span>
              <span className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#43A4A8]" />
                Respuesta en 24h
              </span>
            </div>
          </div>

          <div
            className="lg:col-span-5 nr-fade-up"
            style={{ animationDelay: "200ms" }}
          >
            <div className="nr-hero-img relative">
              <img
                src={HERO_IMAGE}
                alt="Vivienda residencial moderna gestionada por THE NEXT ROOM"
                className="w-full h-[420px] md:h-[560px] object-cover"
              />
              <div className="absolute left-5 bottom-5 right-5 md:left-7 md:bottom-7 md:right-auto bg-white/95 backdrop-blur-sm rounded-2xl border border-[#EAEAEA] p-5 md:p-6 max-w-[320px]">
                <div className="flex items-baseline gap-2">
                  <span className="nr-stat text-[#2E8E92]">100%</span>
                  <span className="text-[13px] nr-text-soft">
                    de propietarios cobran puntual
                  </span>
                </div>
                <p className="mt-2 text-[13px] nr-text-soft leading-snug">
                  Nos convertimos en tu inquilino y garantizamos el pago de la
                  renta cada mes, esté ocupada o no la vivienda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
